module.exports = __webpack_public_path__ + "img/BAOKU_FUXUN.5ee2d79b.png";